import { Component, inject, ViewEncapsulation } from '@angular/core';

import {
	MDIconComponent,
	MDDialogRef,
	MD_DIALOG_REF,
	MDDatePickerInputDirective,
	MDDialogModule,
	MDDropDownComponent,
	IMDDropDownOption
} from '@melodic-ui/components';

@Component({
	selector: 'lrnr-pause-program-dialog',
	standalone: true,
	imports: [MDIconComponent, MDDatePickerInputDirective, MDDialogModule, MDDropDownComponent],
	templateUrl: './pause-program-dialog.component.html',
	styleUrl: './pause-program-dialog.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class PauseProgramDialogComponent {
	private dialogRef: MDDialogRef = inject(MD_DIALOG_REF);

	public reasonOptions: IMDDropDownOption[] = [
		{ value: 'one', label: 'Travel or Relocation' },
		{ value: 'two', label: 'Second option' }
	];

	close(): void {
		this.dialogRef.close();
	}
}
